import pqrsRedux from '../../pqrs/redux/reducer';

//export redux objects
export default {
	pqrsRedux
};
